import styled from "styled-components";
import { Accordion, StyledAccordionItem, token, StyledAccordionHeader, StyledText, StyledIcon, StyledAccordionPanel } from "@zillow/constellation";
const FAQ = styled(Accordion).withConfig({
  displayName: "FAQ",
  componentId: "sc-1r2ez0p-0"
})(["", "{border:none;border-bottom:1px solid ", ";border-radius:0;margin-bottom:0;}", "{border:none;background-color:transparent;flex-direction:row-reverse;padding-left:0;padding-right:0;&:hover{", ":first-child{text-decoration:none;}}", "{margin-left:", "px;margin-right:0;color:", ";}", "{color:inherit;}}", "{background-color:transparent;border-top:none;padding-left:0;padding-right:0;}"], StyledAccordionItem, token("colors.borderLight"), StyledAccordionHeader, StyledText, StyledIcon, token("spacing.sm"), token("colors.brand"), StyledText, StyledAccordionPanel);
FAQ.propTypes = {};
FAQ.defaultProps = {};
export {
  FAQ as default
};
